import {
  CartIcon,
  DeliveredIcon,
  LocationIcon,
  ReceiptIcon,
} from 'static/icons';
import { Text } from 'components';
import { FontSize, StepsEnum } from 'commons';
import * as S from '../styles';

interface Props {
  currentStep: StepsEnum;
  isPickupInStore: boolean;
}

export function DashboardSteps({ currentStep, isPickupInStore }: Props) {
  const { ConfirmEan, Invoice, Transport, Delivered } = StepsEnum;

  const confirmEanSteps = [ConfirmEan, Invoice, Transport, Delivered];
  const invoiceSteps = [Invoice, Transport, Delivered];
  const collectSteps = [Transport, Delivered];
  const deliveredSteps = [Delivered];

  return (
    <S.Wrapper $columnsCount={4}>
      <S.Item $filled={confirmEanSteps.includes(currentStep)}>
        <S.Icon>
          <CartIcon />
        </S.Icon>

        <Text size={FontSize.font12}>Confirmar EAN</Text>
      </S.Item>

      <S.Item $filled={invoiceSteps.includes(currentStep)}>
        <S.Icon>
          <ReceiptIcon />
        </S.Icon>

        <Text size={FontSize.font12}>Emissão e etiqueta</Text>
      </S.Item>

      <S.Item $filled={collectSteps.includes(currentStep)}>
        <S.Icon>
          <LocationIcon />
        </S.Icon>

        <Text size={FontSize.font12}>
          {isPickupInStore ? 'Retirada' : 'Transporte'}
        </Text>
      </S.Item>

      <S.Item $filled={deliveredSteps.includes(currentStep)}>
        <S.Icon>
          <DeliveredIcon />
        </S.Icon>

        <Text size={FontSize.font12}>Entregue</Text>
      </S.Item>
    </S.Wrapper>
  );
}
